<template>
  <div id="exhibitors" class="jf-exhibitors section padding-bottom-65">
    <div class="container">
      <!-- Sponsors -->
      <template v-if="sponsors.length">
        <div class="row">
          <div class="col-xl-12">
            <div class="section-headline centered margin-bottom-25">
              <h3>Sponsors</h3>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-45">
          <div class="col-xl-12">
            <div class="jf-exhibitors__sponsors">
              <component
                :is="sponsor.WebsiteUrl ? 'a' : 'div'"
                v-for="(sponsor, i) in sponsors"
                :key="'s' + i"
                class="jf-exhibitors__sponsor"
                :style="brokenLogos[sponsor.RegistrationId] ? 'display:none' : ''"
                :href="sponsor.WebsiteUrl ? (sponsor.WebsiteUrl.includes('://') ? sponsor.WebsiteUrl : 'https://' + sponsor.WebsiteUrl) : undefined"
                :target="sponsor.WebsiteUrl ? '_blank' : undefined"
                :rel="sponsor.WebsiteUrl ? 'noopener noreferrer' : undefined"
              >
                <img
                  :src="`http://admin.macherusa.com/uploads/exhibitor-logos/exhibitor-${sponsor.RegistrationId}.png?t=${Date.now()}`"
                  :alt="sponsor.BusinessName || sponsor.FullName"
                  @error="$set(brokenLogos, sponsor.RegistrationId, true)"
                >
              </component>
            </div>
          </div>
        </div>
      </template>

      <!-- Exhibitors -->
      <div class="row">
        <div class="col-xl-12">
          <div class="section-headline centered margin-top-45 margin-bottom-45">
            <h3>Job Fair Exhibitors</h3>
            <span>Meet these companies and more at the job fair</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="jf-exhibitors__grid">
            <component
              :is="exhibitor.WebsiteUrl ? 'a' : 'div'"
              v-for="(exhibitor, i) in exhibitors"
              :key="i"
              class="jf-exhibitors__item"
              :style="brokenLogos[exhibitor.RegistrationId] ? 'display:none' : ''"
              :href="exhibitor.WebsiteUrl ? (exhibitor.WebsiteUrl.includes('://') ? exhibitor.WebsiteUrl : 'https://' + exhibitor.WebsiteUrl) : undefined"
              :target="exhibitor.WebsiteUrl ? '_blank' : undefined"
              :rel="exhibitor.WebsiteUrl ? 'noopener noreferrer' : undefined"
            >
              <img
                :src="`http://admin.macherusa.com/uploads/exhibitor-logos/exhibitor-${exhibitor.RegistrationId}.png?t=${Date.now()}`"
                :alt="exhibitor.FullName"
                @error="$set(brokenLogos, exhibitor.RegistrationId, true)"
              >
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    exhibitors: { type: Array, required: true },
    sponsors: { type: Array, default: () => [] }
  },
  data() {
    return { brokenLogos: {} };
  }
};
</script>

<style lang="scss" scoped>
.jf-exhibitors {
  background: #fff;
  padding-top: 25px;

  &__sponsors {
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
  }

  &__sponsor {
    width: 380px;
    height: 180px;
    background: #f9f9f9;
    border: 2px solid #e8e8e8;
    border-radius: 12px;
    padding: 30px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    }

    img {
      max-width: 300px;
      max-height: 120px;
      object-fit: contain;
    }
  }

  &__sponsor-name {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  &__grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }

  &__item {
    width: 180px;
    height: 90px;
    background: #f9f9f9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      filter: grayscale(30%);
      transition: filter 0.2s;
    }

    &:hover img {
      filter: grayscale(0%);
    }
  }
}

@media (max-width: 576px) {
  .jf-exhibitors__item {
    width: 140px;
    height: 70px;
    padding: 10px;
  }
}
</style>
